
<template>
  <div id="mapas">
    <div id="localizacao">
      <!-- <div class="map_location">
        <p class="txt_endereco"> <b> Unidade São José dos Campos </b></p>
        <p class="txt_endereco"> Av. Cassiano Ricardo, 319, sala 703 </p>
        <div class="maps">
            <div class="google-map" :id="maps"></div>
        </div>
      </div> -->
      <div class="map_location">
        <p class="txt_endereco"> <b> Unidade Santos </b></p>
        <p class="txt_endereco"> Av. Conselheiro Nébias, 754, sala 1704</p>
        <div class="maps">
          <div class="google-map" :id="maps"></div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'santos',
  props: ['santos'],
  data: function () {
    return {
      maps: this.name + "-map",
      markerCoordinates: [{
        latitude: -23.967155,
        longitude: -46.323925
      }
    ],
    }
  },
  mounted: function () {
      const element = document.getElementById(this.maps)
      const options = {
        zoom: 14,
        center: new google.maps.LatLng(-23.967155,-46.323925)
      }
      const map = new google.maps.Map(element, options);
      this.markerCoordinates.forEach((coord) => {
        const position = new google.maps.LatLng(coord.latitude, coord.longitude);
        console.log(position)

        const marker = new google.maps.Marker({
          position,
          map
        });
      });
  }
};
</script>

<style scoped>
  #mapas{
    display: flex;
  }
  .google-map {
    padding-right: 1%;
    width: 50%;
    height: 200px;
    margin: 0 auto;
    background: gray;
    margin-bottom: 5%;
  }

</style>
